import type { RefObject } from "react"
import {
  useCallback,
  useState,
  useRef,
} from "react"

export function useRefState<T>(initialValue: T): [T, (v: T) => void, RefObject<T>] {
  const [
    state,
    setState,
  ] = useState<T>(initialValue)

  const ref = useRef<T>(state)

  const setStateAndRef = useCallback(
    (value: T) => {
      ref.current = value
      setState(ref.current)
    },
    [
      setState,
      ref,
    ],
  )

  return [
    state,
    setStateAndRef,
    ref,
  ]
}
